

<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px" fxFlexFill>

  <div fxFlex="initial" style="text-align: center;">
    <img style="height: 150px;" src="/assets/icons/icon-512x512.png" alt="...">
  </div>

  <div fxFlex="initial">
    <mat-card fxFlex style="width: 375px;">

      <form #loginForm="ngForm" class="example-form" (ngSubmit)="onLogin(loginForm)">

        <div fxLayout="column">

            <mat-form-field class="input-full-width">
              <input matInput placeholder="Email Address" 
                    #email 
                    name="email" 
                    value=""
                    ngModel
                    required />
            </mat-form-field>

            <mat-form-field class="input-full-width">
                <input matInput placeholder="Password" 
                      type="password"
                      #password 
                      name="password" 
                      value=""
                      ngModel
                      autocomplete="off"
                      required />
            </mat-form-field>


            <div style="margin: 15px 0px;">
              <mat-checkbox name="stayLoggedIn"  
                          #stayLoggedIn
                          ngModel
                          >STAY LOGGED IN</mat-checkbox>
            </div>


            <button mat-raised-button class="red-button" type="submit" [disabled]="!loginForm.valid">LOGIN</button>

            <!-- <div fxLayout="row" fxLayoutAlign="space-around" style="margin-top:20px;">
              <button type="button" mat-button [routerLink]="['/join']">JOIN ACL</button>
              <button type="button" mat-button [routerLink]="['/forgot-password']">FORGOT PASSWORD</button>
            </div> -->

            <app-progress-bar *ngIf="showSpinner" style="margin-top: 15px;"></app-progress-bar>

        </div>

      </form>
    </mat-card>
  </div>

  <div fxFlex="initial">
    <div class="version-txt">
        version: {{ version }} 
    </div> 
  </div>

</div>
